/** Etiquetas alineadas con `grooves_level_from_total` / `levelFromGroovesTotal` (niveles 1–5). */
export const PROFILE_LEVEL_LABELS = [
  'Oyente',
  'Coleccionista',
  'Melómano',
  'Crate Digger',
  'Maestro del Surco',
];

export function profileLevelLabel(level) {
  const n = Math.min(5, Math.max(1, Number(level) || 1));
  return PROFILE_LEVEL_LABELS[n - 1];
}

/** Umbrales de Grooves ganados (actividad) para subir de nivel — igual que BD `grooves_level_from_total`. */
const GROOVES_LEVEL_THRESHOLDS = [0, 200, 500, 1000, 2500];

export function groovesProgress(groovesEarnedTotal, level) {
  const lv = Math.min(5, Math.max(1, Number(level) || 1));
  const total = Math.max(0, Number(groovesEarnedTotal) || 0);
  const floor = GROOVES_LEVEL_THRESHOLDS[lv - 1] ?? 0;
  const ceiling = lv >= 5 ? GROOVES_LEVEL_THRESHOLDS[4] : GROOVES_LEVEL_THRESHOLDS[lv];
  const span = Math.max(1, ceiling - floor);
  const pct = lv >= 5 && total >= ceiling ? 100 : Math.min(100, Math.round(((total - floor) / span) * 100));
  return {
    current: total,
    nextLevelAt: ceiling,
    floor,
    pct: Number.isFinite(pct) ? pct : 0,
    isMax: lv >= 5 && total >= ceiling,
  };
}
